import { withInsights } from '../../lib/insights';
import connectHits from './connectHits';
var connectHitsWithInsights = withInsights(connectHits);
export default connectHitsWithInsights;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/connectors/hits/connectHitsWithInsights.js
// module id = null
// module chunks = 